var map = {
	"./3d_printing.png": 856,
	"./bg.png": 682,
	"./cad_design.png": 154,
	"./close.png": 87,
	"./comment-icon.png": 336,
	"./custom_fab.png": 732,
	"./full-screen.png": 879,
	"./laser_cutting-v2.webp": 228,
	"./logo.svg": 576,
	"./plasma.png": 257,
	"./play-icon.png": 91,
	"./play1.png": 144,
	"./play10.png": 994,
	"./play2.png": 963,
	"./play3.png": 810,
	"./play4.png": 181,
	"./play5.png": 52,
	"./play7.png": 974,
	"./play8.png": 489,
	"./play9.png": 360,
	"./proto.png": 753,
	"./quote-bg.png": 535,
	"./quote.png": 711,
	"./right-icon.png": 915,
	"./right-img.jpg": 727,
	"./search-icon.png": 549,
	"./star-shape.png": 59,
	"./stay-bg.png": 798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;